export default {

    files: [], mutations :[], queries:[], jobs:[], events:[],
    workflows: [{
        title: "Workflow - start [since v4.66]",

        label: "startWorkflow",

        path: "v2_examples_startWorkflow",

        message:
`mutation {
    startWorkflow (
        name: "TestTemplate123"
        description: "TestTemplate1TestTemplate1TestTemplate1TestTemplate1"
        templateType: "Recht"
        templateId: "TestTemplate1"
        objectType: "KND"
        objectId: "-598392ca:186986d7c31:-7e3d"
    ) {
        workflowNo
        objectId
        externId
        designation
    }
}`

    }, {
        title: "Workflow - upload data [since v5.16]",

        label: "uploadDataToWorkflow",

        path: "v2_examples_uploadDataToWorkflow",

        message:
`mutation {
    uploadDataToWorkflow (
        workflowNo: 123
        data: [{
            name: "customer data"
            fileReference: "customer_123.json"
            contentType: "application/json"    
        }, {
            name: "account data"
            fileReference: "account_123.json"
            contentType: "application/json"    
        }]
    ) {
        uploadedFiles
    }
}`

    }, {
        title: "Workflow - upload documents [since v5.16]",

        label: "uploadDocumentsToWorkflow",

        path: "v2_examples_uploadDocumentsToWorkflow",

        message:
`mutation {
    uploadDocumentsToWorkflow (
        workflowNo: 123
        data: [{
            name: "first document"
            fileReference: "test_123_1.pdf"
            contentType: "application/pdf"    
        }, {
            name: "second document"
            fileReference: "test_123_2.pdf"
            contentType: "application/pdf"    
        }]
    ) {
        uploadedFiles
    }
}`

    }, {
        title: "Workflow - update additional fields [since v5.16]",

        label: "updateWorkflowAdditionalFields",

        path: "v2_examples_updateWorkflowAdditionalFields",

        message:
`mutation {
    updateWorkflowAdditionalFields (
        workflowNo: 123
        additionalFields: [{
            Name: "test"
            Type: TEXT
            Value: "test"    
            ContextObjectClass: CUSTOMER
            ContextObjectOid: "-598392ca:186986d7c31:-7e3d" 
        }]
    ) {
        updatedAdditionalFields
    }
}`

    }], blanks:[]
}